import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { webDeterministicHash } from "../../../utils/webDeterministicHash";
import ValidationError from "../../ZodError";
import { PortfolioAssignment, } from "../types";
const Response = z.object({
    data: PortfolioAssignment,
});
export const portfolioAssignmentsURL = (abstractPortfolioId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/portfolio-plans/${abstractPortfolioId}/assignment`
    : `https://middleware.uat.farther.com/investment/portfolio-plans/${abstractPortfolioId}/assignment`;
export const postPortfolioPlanAssignment = async (abstractPortfolioId, body, idempotencyKey, config) => {
    // this assignment can be done sequentially,
    // so in addition to the idempotencyKey, we are also hashing the body to guarantee uniqueness on multiple requests
    const bodyHash = await webDeterministicHash(body);
    const { data } = await axios.post(portfolioAssignmentsURL(abstractPortfolioId), body, {
        headers: {
            version: "20241114",
            ["idempotency-key"]: `${idempotencyKey}:${bodyHash}`,
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data.data;
    }
    else {
        const errorMessage = `[postPortfolioPlanAssignment.ts] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=postPortfolioPlanAssignment.js.map